// extracted by css-extract-rspack-plugin
module.exports =  {"base":"Header__base--GQ7TJ","logo":"Header__logo--FO8Gq","logoText":"Header__logoText--japUj","brand":"Header__brand--oSFeU"};